import { getHeaders } from './authentication';

// Initial State
let initialState = {
  error: null,
  fetching: false,
  deliveryPharmacies: [],
  otcPharmacies: [],
  teamMembers: [],
  geozones: [], geozone: {},
  page: 0, totalCount: 0, rowsPerPage: 10
};

// GET pharmacies delivery geofences
const GET_DELIVERY_PHARMACY_GEOFENCE = 'GET_DELIVERY_PHARMACY_GEOFENCE';
const GET_DELIVERY_PHARMACY_GEOFENCE_SUCCESS = 'GET_DELIVERY_PHARMACY_GEOFENCE_SUCCESS';
const GET_DELIVERY_PHARMACY_GEOFENCE_FAILURE = 'GET_DELIVERY_PHARMACY_GEOFENCE_FAILURE';

// GET pharmacies delivery geofences
const GET_OTC_PHARMACIES_GEOFENCE = 'GET_OTC_PHARMACIES_GEOFENCE';
const GET_OTC_PHARMACIES_GEOFENCE_SUCCESS = 'GET_OTC_PHARMACIES_GEOFENCE_SUCCESS';
const GET_OTC_PHARMACIES_GEOFENCE_FAILURE = 'GET_OTC_PHARMACIES_GEOFENCE_FAILURE';

// GET geozones
const GET_GEOZONES = 'GET_GEOZONES';
const GET_GEOZONES_SUCCESS = 'GET_GEOZONES_SUCCESS';
const GET_GEOZONES_FAILURE = 'GET_GEOZONES_FAILURE';

// GET a single geozone
const GET_GEOZONE = 'GET_GEOZONE';
const GET_GEOZONE_SUCCESS = 'GET_GEOZONE_SUCCESS';
const GET_GEOZONE_FAILURE = 'GET_GEOZONE_FAILURE';

// ADD a single geozone
const ADD_GEOZONE = 'ADD_GEOZONE';
const ADD_GEOZONE_SUCCESS = 'ADD_GEOZONE_SUCCESS';
const ADD_GEOZONE_FAILURE = 'ADD_GEOZONE_FAILURE';

// UPDATE a single geozone
const UPDATE_GEOZONE = 'UPDATE_GEOZONE';
const UPDATE_GEOZONE_SUCCESS = 'UPDATE_GEOZONE_SUCCESS';
const UPDATE_GEOZONE_FAILURE = 'UPDATE_GEOZONE_FAILURE';

// Action creators
export const addGeozone = (data) => {
  return ({
    types: [ADD_GEOZONE, ADD_GEOZONE_SUCCESS, ADD_GEOZONE_FAILURE],
    payload: {
      request: {
        method: 'POST',
        url: `/geozones`,
        headers: getHeaders(),
        data
      }
    }
  })
}

export const getGeozones = () => {
  return ({
    types: [GET_GEOZONES, GET_GEOZONES_SUCCESS, GET_GEOZONES_FAILURE],
    payload: {
      request: {
        method: 'GET',
        url: `/geozones`,
        headers: getHeaders()
      }
    }
  })
};

export const getDeliveryPharmacyGeofences = () => ({
  types: [GET_DELIVERY_PHARMACY_GEOFENCE, GET_DELIVERY_PHARMACY_GEOFENCE_SUCCESS, GET_DELIVERY_PHARMACY_GEOFENCE_FAILURE],
  payload: {
    request: {
      method: 'GET',
      url: `/pharmacies/V2/geofences?pharmacy_type=all_delivery`,
      headers: getHeaders()
    }
  }
});

export const getOtcPharmaciesGeofences = () => ({
  types: [
    GET_OTC_PHARMACIES_GEOFENCE,
    GET_OTC_PHARMACIES_GEOFENCE_SUCCESS,
    GET_OTC_PHARMACIES_GEOFENCE_FAILURE
  ],
  payload: {
    request: {
      method: 'GET',
      url: `/pharmacies/V2/geofences?pharmacy_type=otc`,
      headers: getHeaders()
    }
  }
});

export const getGeozone = (geozoneID) => {
  return ({
    types: [GET_GEOZONE, GET_GEOZONE_SUCCESS, GET_GEOZONE_FAILURE],
    payload: {
      request: {
        method: 'GET',
        url: `/geozones/${geozoneID}`,
        headers: getHeaders()
      }
    }
  })
}

export const updateGeozone = (geozoneID, data) => {
  return ({
    types: [UPDATE_GEOZONE, UPDATE_GEOZONE_SUCCESS, UPDATE_GEOZONE_FAILURE],
    payload: {
      request: {
        url: `/geozones/${geozoneID}`,
        method: 'PUT',
        headers: getHeaders(),
        data
      }
    }
  })
}

const geozonesReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_GEOZONE:
      return {
        ...state, fetching: true, geozone: {}
      }
    case GET_GEOZONE_SUCCESS:
      return {
        ...state, fetching: false,
        geozone: action.payload.data
      }
    case GET_GEOZONE_FAILURE:
      return {
        ...state,
        error: 'No geozones found',
        geozone: [],
        fetching: false
      }
    case GET_GEOZONES:
      return {
        ...state,
        fetching: true,
        geozones: []
      }
    case GET_GEOZONES_SUCCESS:
      return {
        ...state,
        fetching: false,
        geozones: action.payload.data
      }
    case GET_GEOZONES_FAILURE:
      return {
        ...state,
        error: 'No geozones found',
        geozones: [],
        fetching: false
      }
    case UPDATE_GEOZONE:
      return {
        ...state,
        fetching: true
      }
    case UPDATE_GEOZONE_SUCCESS:
      return {
        ...state,
        error: "Updated Successfully",
        geozone: action.payload.data,
        fetching: false
      }
    case UPDATE_GEOZONE_FAILURE:
      return {
        ...state,
        error: action.error.response.data.error,
        fetching: false
      };
    case GET_DELIVERY_PHARMACY_GEOFENCE:
      return {
        ...state,
        fetching: true,
      };
    case GET_DELIVERY_PHARMACY_GEOFENCE_SUCCESS:
      return {
        ...state,
        fetching: false,
        deliveryPharmacies: action.payload.data,
      };
    case GET_DELIVERY_PHARMACY_GEOFENCE_FAILURE:
      return {
        ...state,
        fetching: false,
        error: 'Problem Updating: ' + action.error.response.data.error,
      };

    case GET_OTC_PHARMACIES_GEOFENCE:
      return {
        ...state,
        fetching: true,
      };

    case GET_OTC_PHARMACIES_GEOFENCE_SUCCESS:
      return {
        ...state,
        fetching: false,
        otcPharmacies: action.payload.data,
      };

    case GET_OTC_PHARMACIES_GEOFENCE_FAILURE:
      return {
        ...state,
        fetching: false,
        error: 'Problem Updating: ' + action.error.response.data.error,
      };

    default:
      return state
  }
}

export default geozonesReducer;
